
var strokeImages12v900lb = {
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-6-1.png?v=1685639779", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-6.pdf?v=1685639136" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-10-1.png?v=1685639791", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-10.pdf?v=1685639136" },
    "15": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-15-1.png?v=1685639816", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-15.pdf?v=1685639135" },
    "20": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-20-1.png?v=1685639824", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-20.pdf?v=1685639136" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-24-1.png?v=1685639829", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-24.pdf?v=1685639135" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-30-1.png?v=1685639834", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-30.pdf?v=1685639135" },
    "35": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-35-1.png?v=1685639839", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-35.pdf?v=1685639136" },
    "40": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-40-1.png?v=1685639843", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-12v-40.pdf?v=1685639136" }
};
var strokeImages24v900lb = {
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-6-1.png?v=1685639847", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-6.pdf?v=1685639136" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-10-1.png?v=1685639852", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-10.pdf?v=1685639135" },
    "15": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-15-1.png?v=1685639857", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-15.pdf?v=1685639135" },
    "20": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-20-1.png?v=1685639862", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-20.pdf?v=1685639135" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-24-1.png?v=1685639866", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-24.pdf?v=1685639135" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-30-1.png?v=1685639872", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-30.pdf?v=1685639135" },
    "35": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-35-1.png?v=1685639877", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-35.pdf?v=1685639136" },
    "40": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-40-1.png?v=1685639883", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-900-24v-40.pdf?v=1685639136" }
};
var strokeImages12v1500lb = {
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-6-1.png?v=1685642457", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-6.pdf?v=1685641947" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-10-1.png?v=1685642463", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-10.pdf?v=1685641947" },
    "15": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-15-1.png?v=1685642467", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-15.pdf?v=1685641947" },
    "20": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-20-1.png?v=1685642471", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-20.pdf?v=1685641947" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-24-1.png?v=1685642475", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-24.pdf?v=1685641947" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-30-1.png?v=1685642479", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-30.pdf?v=1685641947" },
    "35": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-35-1.png?v=1685642483", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-35.pdf?v=1685641947" },
    "40": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-40-1.png?v=1685642487", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-12v-40.pdf?v=1685641947" }
};
var strokeImages24v1500lb = {
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-6-1.png?v=1685642493", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-6.pdf?v=1685641947" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-10-1.png?v=1685642497", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-10.pdf?v=1685641947" },
    "15": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-15-1.png?v=1685642562", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-15.pdf?v=1685641947" },
    "20": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-20-1.png?v=1685642506", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-20.pdf?v=1685641947" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-24-1.png?v=1685642510", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-24.pdf?v=1685641947" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-30-1.png?v=1685642514", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-30.pdf?v=1685641947" },
    "35": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-35-1.png?v=1685642518", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-35.pdf?v=1685641947" },
    "40": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-40-1.png?v=1685642522", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/F-PM-H-1500-24v-40.pdf?v=1685641947" }
};


  jQuery(document).ready(function ($) {
  var strokeSelector = document.getElementById("strokeSelector");
  var forceSelector = document.getElementById("forceSelector");
  var voltageSelector = document.getElementById("voltageSelector");
  var strokeImage = document.getElementById("strokeImage");
  var imageLink = document.getElementById("imageLink");

  function updateImage() {
    var stroke = strokeSelector.value;
    var force = forceSelector.value;
    var voltage = voltageSelector.value
    var selectedMap;
    if (voltage === "12v" && force === "900") {
        selectedMap = strokeImages12v900lb;
      } else if (voltage === "24v" && force === "900") {
        selectedMap = strokeImages24v900lb;
      } else if (voltage === "12v" && force === "1500") {
        selectedMap = strokeImages12v1500lb;
      } else if (voltage === "24v" && force === "1500") {
        selectedMap = strokeImages24v1500lb;
    }
    
    if (selectedMap[stroke]) {
      strokeImage.src = selectedMap[stroke].img;
      imageLink.href = selectedMap[stroke].link;
    }
  }
  function preloadImages(map) {
    Object.values(map).forEach(entry => {
      const img = new Image();
      img.src = entry.img;
    });
  }
  window.addEventListener('load', () => {
    setTimeout(() => {
      preloadImages(strokeImagesAlllb);
    }, 500);
  });
  
  strokeSelector?.addEventListener("change", updateImage);
  forceSelector?.addEventListener("change", updateImage);
  voltageSelector?.addEventListener("change", updateImage);

  function bindDropdownListeners() {
    const dropdownToggles = document.querySelectorAll(".dropdown-trigger");
    dropdownToggles.forEach(trigger => {
      if (!trigger.dataset.listenerAdded) {
        trigger.dataset.listenerAdded = "true";
        trigger.addEventListener("click", () => {
        const detailsSection = trigger.nextElementSibling;
        if (detailsSection) {
          detailsSection.style.transition = "max-height 0.3s ease, padding 0.3s ease";

          if (detailsSection.classList.contains("open")) {
            // Close
            detailsSection.style.maxHeight = "0px";
            detailsSection.classList.remove("open");
          } else {
            // Open
            detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
            detailsSection.classList.add("open");

            // If content includes images, re-measure once they load
            detailsSection.querySelectorAll("img").forEach(img => {
              if (!img.complete) {
                img.addEventListener("load", () => {
                  if (detailsSection.classList.contains("open")) {
                    detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
                  }
                });
              }
            });
          }
        }
      });
      }
    });
  }
  // Product tab toggle
  let lastChecked = document.querySelector("input[type='radio'][name='productTabs']");
  document.querySelectorAll("input[type='radio'][name='productTabs']").forEach(radio => {
    radio.addEventListener("click", function () {
      if (lastChecked === this) {
        this.checked = false;
        lastChecked = null;
      } else {
        lastChecked = this;
      }
    });
  });

    const contentTarget = document.querySelector(".fg-product-additional-content");
    if (contentTarget) {
      const contentObserver = new MutationObserver(() => {
        bindDropdownListeners();
        hideNearestH2Above(".site-wrapper");
        setupYouTubeThumbnails();
      });
      contentObserver.observe(contentTarget, { childList: true, subtree: true });
    }

    // Function to hide nearest <h2> above a target
    function hideNearestH2Above(selector) {
      const element = document.querySelector(selector);
      if (!element) return;

      let h2 = element.previousElementSibling;
      while (h2 && h2.tagName !== "H2") {
        h2 = h2.previousElementSibling;
      }

      if (h2) h2.style.display = "none";
    }

    
    function setupYouTubeThumbnails() {
      var youtube = document.querySelectorAll(".youtubeVideo:not([data-initialized])");
      youtube.forEach(el => {
        el.dataset.initialized = "true";
        el.addEventListener("click", function () {
          var iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("allow", "autoplay");
          iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
          this.innerHTML = "";
          this.appendChild(iframe);
        });
      });
    }

    // Initial bindings
    bindDropdownListeners();
    hideNearestH2Above(".site-wrapper");
    setupYouTubeThumbnails();

  });
